

import React, { Fragment } from 'react';


// Components

import ModalHeader from '@common-components/headers/ModalHeader';
import { FormattedMessage } from 'react-intl';
import { Button }from '@cmsgov/design-system';



const FileSizeExceedingErrorModal = props => {
    const {
        modalHeaderProps,
        actions: {
            hideModal
        },
        modal: {
            modalData: {
                fileSizeLimit
            }
        },
        secondaryTopAnchors: [
            anchor_1
        ],
        boundAnchor
    } = props;

    const sizeLimit = (fileSizeLimit / Math.pow(2, 20)).toFixed(2);

    return (
        <Fragment>
            <ModalHeader { ...{ ...modalHeaderProps, hideCloseIcon: true }} />
            <div className="grid-container">
                <div className = 'gi-modal__body' id={`${modalHeaderProps.modalId}_body`}>
                    <p>
                        <FormattedMessage
                            id = 'modals.file_size_exceeding_warning'
                            values = {{ sizeLimit }}
                        />
                    </p>
                </div>
            </div>
            <div className = 'gi-modal__controls'>
                <Button
                    className = 'usa-button gi-button gi-button__primary'
                    onClick = { hideModal }
                    inputRef = { boundAnchor(anchor_1) }
                >
                    <FormattedMessage id = 'button.close'/>
                </Button>
            </div>
        </Fragment>
    );
};

export default FileSizeExceedingErrorModal;